import * as React from 'react'

const BriefAutofillCheck = props => (
  <svg width="42" height="33" viewBox="0 0 42 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M39.5 2L15 29.5L2 17" stroke="#31B35C" strokeWidth="4" strokeLinecap="round" />
  </svg>
)

export default BriefAutofillCheck
